<template>
  <a-select
    :disabled="disabled"
    :multiple="false"
    :placeholder="placeholder"
    :value="value"
    :allow-clear="allowClear"
    option-filter-prop="title"
    show-search
    :class="class"
    @change="onChange"
  >
    <a-select-option
      v-for="item in records?.records"
      :key="item.id"
      :title="item.name"
      :value="item.id"
      >{{ item.name }}</a-select-option
    >
  </a-select>
</template>

<script lang="ts">
import { WorkPackageService } from "@/views/maintenance/workPackage/workPackage.service";
import { defineComponent, onMounted } from "vue";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
/**
 * 工作包
 *
 * 使用方式:
 * <workPackage-select v-model:value="formRef.id"></workPackage-select>
 */
export default defineComponent({
  isGlobal: true,
  props: {
    value: {
      type: String,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    api: {
      type: String,
    },
    defaultValue: {
      type: String,
      default: undefined,
    },
    class: {
      type: String,
      default: "append-to-parentnode",
    },
    status: {
      type: Number,
      default: 1,
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const { data: records, run, loading } = WorkPackageService.useSimpleListApi();
    const onChange = async (id) => {
      emit("update:value", id);
      let item = ((records?.value?.records || []) as Array<any>).find((r) => r.id == id);
      emit("change", item);
    };
    onMountedOrActivated(async () => {
      await run({ status: props.status });
      // console.log("🚀 ~ file: index.vue:65 ~ onMounted ~ records:", records);
      // if (props.defaultValue) {
      //   let item = ((records?.value? || []) as Array<any>).find((r) => r.bizType == props.defaultValue);
      //   if (item) {
      //     emit("update:value", item.id);
      //     emit("change", item.id);
      //   }
      // }
    });

    return {
      records,
      loading,
      onChange,
    };
  },
});
</script>
